import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import {ClientRequest} from  '../../ClientRequest';
import storage from 'local-storage-fallback';


@Injectable()
export class AuthenticationService {

  constructor(private request: ClientRequest){}
  refreshToken(): Observable<any> {
    return this.request.get('/auth/token/refresh').map((response: HttpResponse<any>) => {
      return response;
    });
  };
  
  login(username: string, password: string): Observable<any> {
    return this.request.post( '/auth/login', {email: username, password: password})
    .map((response: HttpResponse<any>) => {
        return response;
    });
  }

  logout(): void {
    storage.clear();
  }
  isLoged(): boolean{
    return storage.getItem('currentUser') ? true : false;
  }
  requestPassword(email){
    return this.request.post('/auth/password/request', {email: email}).map((response: HttpResponse<any>) => {
        return response;
    });
  }
  validateToken(token, email){
    return this.request.post('/auth/token/validate/'+token, {email: email}).map((response: HttpResponse<any>) => {
      return response;
    });
  }
  resetPassword(token, data){
    return this.request.post('/auth/password/reset/'+token, data).map((response: HttpResponse<any>) => {
      return response;
    });
  }
}